import { takeEvery, fork, put, all, call } from "redux-saga/effects";

// Login Redux States
import { FORGET_PASSWORD, SET_NEW_PASSWORD, SET_NEW_PASSWORD_AFTER_EXPIRE } from "./actionTypes";
import {
  userForgetPasswordSuccess,
  apiError,
  setNewPswSuccess,
} from "./actions";

//Include Both Helper File with needed methods
import axios from "axios";
import { clearDateStorage } from "../../../pages/Authentication/helpers";
import { isArray } from "lodash";

//If user is send successfully send mail link then dispatch redux action's are directly from here.
function* userForgetPassword({ payload: { user } }) {
  try {
    const response = yield call(axios.post, "/security/user/password-reset", {
      email: user.email,
      slug: user.slug,
    });
    if (
      (response.status >= 200 || response.status <= 299) &&
      response.data &&
      response.data.data
    ) {
      let message = response.data.message;
      yield put(userForgetPasswordSuccess(message));
      clearDateStorage();
    } else {
      throw response.data;
    }
  } catch (error) {
    let message;
    if (error.response && error.response.status) {
      switch (error.response.status) {
        // case 400:
        //   message = "Invalid data";
        //   break;
        case 401:
          message = "Your session has expired";
          break;
        // case 404:
        //   message = "Sorry! the page you are looking for could not be found";
        //   break;
        case 500:
          message =
            "Sorry! something went wrong, please contact our support team";
          break;
        default:
          if (error.response.data && error.response.data.message)
            message = error.response.data.message;
          else message = error.message;
          break;
      }
    }
    yield put(apiError(message));
  }
}

function* setNewPsw({ payload: { user, history, pswToken } }) {
  try {
    const response = yield call(
      axios.post,
      "/user/password-change",
      {
        password: user.password,
      },
      { headers: { Authorization: pswToken } }
    );
    if (
      (response.status >= 200 || response.status <= 299) &&
      response.data &&
      response.data.data
    ) {
      let message = response.data.message;
      yield put(setNewPswSuccess(message));
      setTimeout(() => {
        history.push("/login");
      }, 2500);
    } else {
      throw response.data;
    }
  } catch (error) {
    let message;
    if (error.response && error.response.status) {
      //TODO: Incluir os tratamento necessário para apresentar os erros corretos
      switch (error.response.status) {
        case 400:
          if (isArray(error?.response?.data?.message)) {
            error?.response?.data?.message.forEach((el) => {
              if (el.value === 'password must be different from the previous') {
          message = el.value;
              }
            });
          } else {
            message = "Invalid data";
          }
          break;
        case 401:
          message = "Your session has expired";
          break;
        case 404:
          message = "Sorry! the page you are looking for could not be found";
          break;
        case 500:
          message =
            "Sorry! something went wrong, please contact our support team";
          break;
        default:
          if (error.response.data && error.response.data.message)
            message = error.response.data.message;
          else message = error.message;
          break;
      }
    }
    yield put(apiError(message));
  }
}

function* setNewPswAfterExpire({ payload: { user, history, pswToken } }) {
  try {
    const response = yield call(
      axios.post,
      "user/expired-password-change",
      {
        password: user.password,
      },
      { headers: { Authorization: pswToken } }
    );
    if (
      (response.status >= 200 || response.status <= 299) &&
      response.data &&
      response.data.data
    ) {
      let message = response.data.message;
      yield put(setNewPswSuccess(message));
      setTimeout(() => {
        history.push("/login");
      }, 2500);
    } else {
      throw response.data;
    }
  } catch (error) {
    let message;
    if (error.response && error.response.status) {
      //TODO: Incluir os tratamento necessário para apresentar os erros corretos
      switch (error.response.status) {
        case 400:
          if (isArray(error?.response?.data?.message)) {
            error?.response?.data?.message.forEach((el) => {
              if (el.value === 'password must be different from the previous') {
          message = el.value;
              }
            });
          } else {
            message = "Invalid data";
          }
          break;
        case 401:
          message = "Your session has expired";
          break;
        case 404:
          message = "Sorry! the page you are looking for could not be found";
          break;
        case 500:
          message =
            "Sorry! something went wrong, please contact our support team";
          break;
        default:
          if (error.response.data && error.response.data.message)
            message = error.response.data.message;
          else message = error.message;
          break;
      }
    }
    yield put(apiError(message));
  }
}
export function* watchUserPasswordForget() {
  yield takeEvery(FORGET_PASSWORD, userForgetPassword);
}
export function* watchUserPasswordChange() {
  yield takeEvery(SET_NEW_PASSWORD, setNewPsw);
}
export function* watchUserPasswordChangeAfterExpire() {
  yield takeEvery(SET_NEW_PASSWORD_AFTER_EXPIRE, setNewPswAfterExpire);
}

function* forgetPasswordSaga() {
  yield all([fork(watchUserPasswordForget), fork(watchUserPasswordChange), fork(watchUserPasswordChangeAfterExpire)]);
}

export default forgetPasswordSaga;
